import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { DocViewerDocumentDetails } from '../document-viewer/document-viewer.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DocumentsService } from 'src/app/services/sections/documents/documents.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { getContentType } from 'src/app/models/enum/content-type.enum';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from '../toast/models/toast-type.enum';
import { Toast } from '../toast/models/toast.model';
import { saveAs } from 'file-saver-es';
import { groupBy } from 'lodash-es';
import { takeUntil } from 'rxjs/operators';
import { Document } from '../../models/document.model';
import { JobDigitalLogFormInfo } from 'src/app/models/job-digital-log-form-info.model';
import { GlobalUtilsService } from 'src/app/services/ui/global-utils.service';
import * as moment from 'moment';


@Component({
	selector: 'dl-form-documents',
	templateUrl: './dl-form-documents.component.html',
	styleUrls: ['./dl-form-documents.component.scss', '../stylesheets/document-viewer.scss']
})
export class DlFormDocumentsComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('sidenav', { static: true }) sidenav: MatSidenav;

	public documents: Map<string, Document[]> = new Map();
	public isOpened = false;
	public loadingMessage = null;
	public docs: Document[] = [];

	public selectedDocumentDetails: DocViewerDocumentDetails = null;
	public dlFormInfos: JobDigitalLogFormInfo[] = [];
	public dlFormInfo: JobDigitalLogFormInfo;

	private unsubscriber$ = new Subject<void>();
	private isScreenMd = window.innerWidth <= 768;
	public isMobileDevice: boolean;
	public readonly moment = moment;

	constructor(
		private route: ActivatedRoute,
		private documentsService: DocumentsService,
		private _sanitizer: DomSanitizer
	) { }

	ngOnInit(): void {
		GlobalSettingsService.navigationBarActions.set(
			'download_all_documents',
			{
				action: this.downloadAllZip.bind(this),
				icon: 'cloud_download',
				text: 'Download all',
				listOrder: 1
			}
		);

		this.isMobileDevice = GlobalUtilsService.isMobileDevice;
		this.dlFormInfo = this.route.snapshot.data.documents as JobDigitalLogFormInfo;

		if (!this.isScreenMd && this.dlFormInfo?.groups?.length > 0) {
			if (this.dlFormInfo.groups[0]?.timeslots?.length > 0) {
				this.showDocument(this.dlFormInfo.groups[0].timeslots[0].documents[0].documentId, this.dlFormInfo.groups[0].timeslots[0].documents[0].fileName);
			} else if (this.dlFormInfo.groups[0]?.assets[0]?.timeslots?.length > 0){
				this.showDocument(this.dlFormInfo.groups[0].assets[0].timeslots[0].documents[0].documentId, this.dlFormInfo.groups[0].assets[0].timeslots[0].documents[0].fileName);
			}
		}
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}

	public showDocument(documentId: number, documentName: string) {
		this.selectedDocumentDetails = null;

		if (!this.isOpened) {
			this.toggleSlide();
		}
		this.documentsService
			.getPhotoViewerDocument(this.route.snapshot.paramMap.get('token'), documentId)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe((content) => {
				this.isOpened = true;
				this.selectedDocumentDetails = { documentId, content, documentDisplayName: documentName, documentDownloadName: documentName };
			}, () => {
				this.selectedDocumentDetails = null;
			});
	}

	public downloadAllZip(): void {
		if (TokenHelper.getToken(this.route)) {
			ToastService.pushToast({
				icon: 'info',
				text: 'Please wait until the zip file is ready...',
				type: ToastType.Info,
				timeout: 10000
			} as Toast);
			this.documentsService.getPhotoViewerDocumentsZip(TokenHelper.getToken(this.route)).subscribe(
				(content) => saveAs(content, 'documents-archive.zip')
			);
		}
	}

	public toggleSlide() {
		this.isOpened = !this.isOpened;
		this.sidenav.toggle();
	}

	public downloadFile(documentId: number, fileName: string) {
		event.stopPropagation();
		this.documentsService
			.getPhotoViewerDocument(this.route.snapshot.paramMap.get('token'), documentId)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe((content) => {
				saveAs(content, fileName);
			},
				() => console.log('There was an error while downloading')
			);
	}

	public getHeaderClass(document: Document): string {
		const enumName = getContentType(document.contentType).toLowerCase();
		return `mat-card-avatar header-image ${enumName}`;
	}

	public getDocIcon(document: Document): string {
		const enumName = getContentType(document.contentType).toLowerCase();
		return `header-image mat-list-avatar ${enumName}`;
	}

	public getImageThumnail(photo): SafeResourceUrl {
		return this._sanitizer.bypassSecurityTrustResourceUrl(`data:${photo.contentType};base64, ${photo.thumbnailBase64}`);
	}

	private generatorRandomName(): string {
		const stringArr = [];
		for (let i = 0; i < 4; i++) {
			const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			stringArr.push(S4);
		}
		return stringArr.join('-');
	}
}
